import React from 'react';
import { withStyles } from '@material-ui/styles';
import { compose } from 'redux';

import withShowModal from "../../hocs/with_show_modal.js";

import { ModalTypeInfo, ModalTypeConfirm } from "./constants.js";
import ModalConfirm from "./modal_confirm.js";

const styles = theme => ({
  root: {
  },
});

// TODO: Add documentation
class ModalContainer extends React.Component {

  constructor(props) {
    super(props);

    this.state = {

    }

    this.modalByType = this.modalByType.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    const { modalShowed, modalInfo } = props;

    return {
      modalInfo: modalInfo,
      modalShowed: modalShowed
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return JSON.stringify(this.state.modalShowed) !== JSON.stringify(nextState.modalShowed) ||
           JSON.stringify(this.state.modalInfo) !== JSON.stringify(nextState.modalInfo);
  }

  modalByType() {
    const { type, modalContext } = this.props;
    const { hideModal, onModalHidden } = modalContext;

    const { modalShowed, modalInfo } = this.state;
    
    if(type === ModalTypeConfirm) {
      return <ModalConfirm open = { modalShowed }
                           close = { hideModal }
                           onClose = { onModalHidden }
                           { ...modalInfo }/>
    }
    return undefined;
  }


  render() {
    return <React.Fragment>
      { this.modalByType() }
    </React.Fragment>
  }
}

export default compose(withShowModal, withStyles(styles))(ModalContainer);
export { ModalContainer as RawModalContainer };

